// extracted by mini-css-extract-plugin
module.exports = {"class-attachments-title":"styles__class-attachments-title___1sJYK","attachment-quantity":"styles__attachment-quantity___1M5Ll","view-all-button":"styles__view-all-button___2CbPk"};